/*
  ms-cart-guard.js — un complemento no puede viajar solo.

  POR QUE EXISTE
  Los complementos tienen el 50% HORNEADO en la variante ($494.45 contra $899 de
  lista). Eso los vuelve un SKU barato y comprable por si mismo. Reportado por el
  cliente el 26-ago y reproducido con carrito real: agregas suscripcion +
  complemento, quitas la linea de la suscripcion, y el complemento se queda solo
  a mitad de precio. Lo mismo pasa si alguien agrega el complemento directo, sin
  pasar por la ficha.

  QUE HACE
  Cada vez que el carrito cambia, si quedan complementos y NINGUN producto que
  los acompanie, los saca. La regla es del cliente: "los complementos solo se
  pueden agregar al carrito si llevan otro producto, sea suscripcion o no".

  COMO RECONOCE UN COMPLEMENTO
  Por la propiedad `_complemento` que pone el bloque ms-oferta, Y ADEMAS por el
  handle `complemento-*`. Las dos, no una: la propiedad no viaja si alguien
  agrega el producto por fuera del bloque, que es justo el hueco que hay que tapar.

  TAMBIEN CUBRE LOS UPSELLS DE KACHING BUNDLES (act. 2026-08-31)
  Reportado por el cliente sobre /pages/pack_amor: agregas el paquete de Kaching
  con su upsell, quitas el paquete, y el upsell se queda solo con su precio de
  prueba. Kaching etiqueta cada linea suya con la propiedad `__kaching_bundles`,
  un JSON: la linea PRINCIPAL trae `"main":true` y la del upsell trae
  `"upsell":"<id>"` y nunca `main`. Verificado en pedidos reales: #14871 y #14873
  (upsell) contra #14855 (principal). Por eso solo se trata como upsell la linea
  que trae `upsell`: reconocer "cualquier linea de Kaching que no sea main" seria
  mas amplio, pero se llevaria por delante una linea principal el dia que Kaching
  deje de marcarla, y borrar de mas es mucho peor que borrar de menos.

  LOS REGALOS `regalo-*` NO son complementos: no les aplica el tope de 1 (el 3x2
  de 6 frascos entrega 2). Tienen su propia regla, la del 3x2 de
  /pages/arma-tu-paquete: ver «EL FRASCO GRATIS DEL 3x2» mas abajo.

  LIMITE DECLARADO
  Esto es una malla de JavaScript, no una regla de servidor. Cubre a cualquier
  persona usando la tienda con normalidad, pero no a quien llame la API a mano.
  El candado de verdad seria dejar de hornear el 50% en la variante (decision V5,
  pendiente de Antonio) o una Shopify Function de validacion de carrito.
*/
(function () {
  'use strict';

  var PROP = '_complemento';
  var PROP_KACHING = '__kaching_bundles';
  var HANDLE = /^complemento(-|$)/i;
  var FUENTE = 'ms-cart-guard';
  var MAX_POR_COMPLEMENTO = 1;
  var ESTILO_ID = 'ms-cart-guard-styles';
  var trabajando = false;
  var enVuelo = null;
  var ultimoCarrito = null;

  function raiz() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function esComplemento(item) {
    var props = item.properties || {};
    if (props[PROP] === '1' || props[PROP] === 1 || props[PROP] === true) return true;
    return HANDLE.test(item.handle || '');
  }

  /* Upsell de Kaching Bundles: ver la cabecera del archivo para el porque de
     exigir `upsell` y no conformarse con "no es main". */
  function esUpsellKaching(item) {
    var crudo = (item.properties || {})[PROP_KACHING];
    if (!crudo) return false;

    var datos;
    try {
      datos = typeof crudo === 'string' ? JSON.parse(crudo) : crudo;
    } catch (e) {
      return false;                       // Kaching cambio el formato: no adivinar
    }
    if (!datos || typeof datos !== 'object') return false;
    if (datos.main === true || datos.main === 'true') return false;   // es la principal

    return !!datos.upsell;
  }

  /* Todo lo que no puede viajar solo en el carrito: complementos de la ficha y
     upsells de Kaching. Mismas dos reglas para los dos, que es lo que pidio el
     cliente: sin acompaniante se van, y como mucho uno de cada uno. */
  function esDependiente(item) {
    return esComplemento(item) || esUpsellKaching(item);
  }

  /* ─────────────────────────────────────────────────────────────────────────
     EL 2x1 DE ANIVERSARIO

     Su variante vale $449.50, que es el precio POR FRASCO, y la oferta son
     DOS por $899 cada 60 dias. El precio por unidad es lo que permite que la
     linea lleve el SKU de 1 frasco que la bodega ya conoce, en vez de estrenar
     un codigo. El costo de esa decision es que la linea, suelta, es comprable
     a mitad de precio. Probado el 2026-09-01 contra el carrito real:

       1 unidad sin plan          -> $449.50 por UN frasco
       1 unidad con plan          -> $449.50 por UN frasco, recurrente
       2 unidades con plan de 30d -> 2 frascos $764.16 CADA MES

     Por eso la linea del 2x1 solo es valida si cumple las dos condiciones con
     las que la agrega el buy box: plan de 60 dias, y cantidad PAR (cada par es
     una oferta). Si el plan no es el correcto la linea se saca —`update.js` no
     puede cambiar de plan— y si la cantidad es impar se baja al par de abajo,
     con minimo 2: nunca se redondea hacia arriba, porque eso regalaria un
     frasco.

     Se reconoce por convencion (handle `aniversario-*` + variante «2x1»), no
     por ids: asi cubre los cuatro productos y los que vengan.
     ───────────────────────────────────────────────────────────────────────── */
  /* (act. 2026-09-15) El 2x1 se puede elegir cada 30, 60, 90 o 180 días en
     /pages/arma-tu-paquete y en TODAS cuesta lo mismo que en las fichas:
     $449.50 por frasco. Como cada plan de Appstle trae su propio descuento
     (30d 15%, 90d 20%, 180d 23.08%), cada frecuencia tiene SU variante con el
     precio base inflado para que tras el descuento aterrice en $449.50 — el
     mismo truco que el Pack. Por eso cada variante vale SOLO con su plan: la
     «2x1» de $449.50 con el plan de 30 días daría $382.08 por frasco. */
  /* (act. 2026-09-18) Carlos: la suscripción es SOLO cada 60 días. Las
     variantes «2x1 · 30/90/180 días» siguen existiendo (apagadas en fichas y
     landing) pero ya no son válidas en el carrito: si alguien las mete, salen.
     Para reactivar una frecuencia, se vuelve a listar aquí y en «plan_names»
     de la landing. */
  var VARIANTES_2X1 = {
    '2x1': '60 días',
    /* (act. 2026-09-22) El Pack Daily vende su escalón de 1 Pack cada 30 días,
       igual que el Pack del Amor: variante inflada a $528.82 que con el plan de
       30 días (-15%) aterriza en los mismos $449.50 por frasco. */
    '2x1 · 30 días': '30 días'
  };

  /* Toda variante «2x1…» de aniversario-* es un 2x1, esté o no en el mapa:
     así una variante apagada (sin plan válido en VARIANTES_2X1) no se cuela,
     porque su plan nunca coincide y la línea sale. */
  function es2x1(item) {
    return /^aniversario-/i.test(item.handle || '') &&
           /^2x1/i.test(String(item.variant_title || '').trim());
  }

  function planDe(item) {
    var a = item.selling_plan_allocation;
    return (a && a.selling_plan && a.selling_plan.name) ? String(a.selling_plan.name).trim() : '';
  }

  /* ─── EL PACK DE ANIVERSARIO ───────────────────────────────────────────────
     Mismo problema que el 2x1, con otra forma. El producto entero vive en el
     grupo de suscripcion, asi que TODAS sus variantes aceptan plan — tambien
     las de compra unica, que estan mas baratas porque su precio no trae el
     inflado que compensa el descuento del plan. Pegarle el plan de 60 dias a
     la variante «2+2» daba 4 frascos a $1,438.40 recurrentes en vez de $1,798.

     La regla es la del buy box: cada variante de suscripcion tiene UN plan y
     las de compra unica no llevan ninguno. Lo que no cumpla, fuera.
     ───────────────────────────────────────────────────────────────────────── */
  var PACK_PLANES = {
    'Pack Amor suscripción': '30 días',
    'Pack Amor 2x1': '60 días',
    /* (act. 2026-09-21) Pack Daily = Seeds + Rebira, mismas reglas y precios.
       Sus variantes se llaman «Pack Daily …» a propósito: así sus mitades
       nunca se emparejan con las del Pack del Amor si van en el mismo carrito. */
    'Pack Daily suscripción': '30 días',
    'Pack Daily 2x1': '60 días',
    /* (act. 2026-10-15) El 3.er escalón de suscripción (3 Packs, cada 90 días)
       usa la variante «triple suscripción». No estaba en este mapa, así que el
       guardián la tomaba por una variante de compra única con plan y la SACABA
       del carrito: el cliente agregaba el pack y el carrito quedaba vacío. */
    'Pack Amor triple suscripción': '90 días',
    'Pack Daily triple suscripción': '90 días',
  };

  function esPack(item) {
    return /^pack-aniv-/i.test(item.handle || '');
  }

  function packValido(item) {
    var titulo = String(item.variant_title || '').trim();
    var plan = planDe(item);
    var esperado = PACK_PLANES[titulo];
    if (esperado) return plan === esperado;
    /* Variante de compra unica (o una de suscripcion apagada): sin plan. */
    return plan === '';
  }

  /* ─── EL PACK SE VENDE EN PAREJA ──────────────────────────────────────────
     El pack cobra POR FRASCO ($449.50) porque su precio sale de comprar los dos
     productos juntos. En el carrito nada impedia romper la pareja: borrar la
     linea de Honey Dee y subir la de Seeds deja frascos sueltos a $449.50, mas
     barato que el mejor precio de ese producto solo ($539.40 en el paquete de
     6). Paso de verdad: pedidos #14996 (4 Seeds, 0 Honey) y #14997 (2 Seeds,
     1 Honey).

     La regla es la del buy box: para la MISMA variante y el MISMO plan, las dos
     mitades llevan la misma cantidad. Lo que sobre de un lado se recorta; si
     una mitad desaparece, la otra se va con ella — media pareja no es el pack.
     ───────────────────────────────────────────────────────────────────────── */
  function clavePack(item) {
    return String(item.variant_title || '').trim() + '|' + planDe(item);
  }

  function corregirPack(items, updates) {
    var grupos = {};

    items.forEach(function (item) {
      if (!esPack(item)) return;
      var k = clavePack(item);
      if (!grupos[k]) grupos[k] = {};
      var h = item.handle;
      if (!grupos[k][h]) grupos[k][h] = { total: 0, lineas: [] };
      grupos[k][h].total += parseInt(item.quantity, 10) || 0;
      grupos[k][h].lineas.push(item);
    });

    var hubo = false;

    Object.keys(grupos).forEach(function (k) {
      var porMitad = grupos[k];
      var handles = Object.keys(porMitad);

      /* Con una sola mitad presente el objetivo es 0: no hay pareja. */
      var objetivo = 0;
      if (handles.length >= 2) {
        objetivo = porMitad[handles[0]].total;
        handles.forEach(function (h) {
          if (porMitad[h].total < objetivo) objetivo = porMitad[h].total;
        });
      }

      handles.forEach(function (h) {
        var sobra = porMitad[h].total - objetivo;
        if (sobra <= 0) return;
        var lineas = porMitad[h].lineas;
        for (var i = lineas.length - 1; i >= 0 && sobra > 0; i--) {
          var li = lineas[i];
          var q = parseInt(li.quantity, 10) || 0;
          var quitar = Math.min(sobra, q);
          updates[li.key] = q - quitar;
          sobra -= quitar;
          hubo = true;
        }
      });
    });

    return hubo;
  }

  /* ─── EL 2x1 SE CUENTA POR CARRITO, NO POR LINEA (act. 2026-09-15) ─────────
     Antes cada linea tenia que ser par. En /pages/arma-tu-paquete el cliente
     MEZCLA: 1 Seeds + 1 Honey son dos lineas de 1 unidad, y la regla vieja las
     borraba las dos. La oferta sigue siendo la misma —cada par de frascos del
     2x1 cuesta $899— asi que lo que tiene que ser par es el TOTAL de frascos
     2x1 con plan de 60 dias en todo el carrito.
     Con plan equivocado la linea sale (update.js no cambia planes). Si el
     total queda impar se recorta 1 frasco de la ultima linea: nunca se sube,
     porque eso regalaria un frasco. Con menos de 2 no hay oferta y sale todo. */
  /* Los pares se cuentan POR FRECUENCIA: 1 Seeds cada 30 días + 1 Honey cada
     60 días no son un 2x1 (Appstle los manda en contratos distintos), así que
     cada frecuencia tiene que cerrar par por su cuenta. */
  function corregir2x1(items, updates) {
    var hubo = false;
    var grupos = {};

    items.forEach(function (item) {
      if (!es2x1(item)) return;
      var plan = planDe(item);
      if (plan !== VARIANTES_2X1[String(item.variant_title || '').trim()]) {
        updates[item.key] = 0;
        hubo = true;
        return;
      }
      if (!grupos[plan]) grupos[plan] = { total: 0, lineas: [] };
      var q = parseInt(item.quantity, 10) || 0;
      grupos[plan].lineas.push({ item: item, q: q });
      grupos[plan].total += q;
    });

    Object.keys(grupos).forEach(function (plan) {
      var g = grupos[plan];
      var sobra = g.total < 2 ? g.total : g.total % 2;
      for (var i = g.lineas.length - 1; i >= 0 && sobra > 0; i--) {
        var quitar = Math.min(sobra, g.lineas[i].q);
        updates[g.lineas[i].item.key] = g.lineas[i].q - quitar;
        sobra -= quitar;
        hubo = true;
      }
    });
    return hubo;
  }

  /* ─── EL FRASCO GRATIS DEL 3x2 (act. 2026-09-15) ───────────────────────────
     /pages/arma-tu-paquete vende el 3x2 mezclable: por cada 2 frascos pagados
     de compra unica (aniversario-* variante «1 frasco», $899) va 1 frasco
     `regalo-*` a $0 del producto que el cliente eligio. El regalo es un
     producto aparte a $0, asi que suelto es un frasco gratis. Reglas:
       · el regalo no lleva plan (con plan se volveria un frasco gratis de
         por vida);
       · gratis permitidos = piso(pagados / 2). Si el cliente quita un
         pagado, el regalo que sobra se va con el. */
  function esRegalo(item) {
    return /^regalo-/i.test(item.handle || '');
  }

  function esPagado3x2(item) {
    return /^aniversario-/i.test(item.handle || '') &&
           String(item.variant_title || '').trim() === '1 frasco' &&
           planDe(item) === '';
  }

  function corregirRegalos(items, updates) {
    var hubo = false;
    var pagados = 0;
    var regalos = [];

    items.forEach(function (item) {
      var q = updates[item.key] !== undefined ? updates[item.key] : (parseInt(item.quantity, 10) || 0);
      if (esPagado3x2(item)) pagados += q;
      if (!esRegalo(item)) return;
      if (planDe(item) !== '') {
        updates[item.key] = 0;
        hubo = true;
        return;
      }
      regalos.push({ item: item, q: q });
    });

    var permitidos = Math.floor(pagados / 2);
    var total = regalos.reduce(function (s, r) { return s + r.q; }, 0);
    var sobra = total - permitidos;
    for (var i = regalos.length - 1; i >= 0 && sobra > 0; i--) {
      var quitar = Math.min(sobra, regalos[i].q);
      updates[regalos[i].item.key] = regalos[i].q - quitar;
      sobra -= quitar;
      hubo = true;
    }
    return hubo;
  }

  /* Los mismos ids de seccion que pide ms-oferta, para que el cajon y el icono
     del carrito se redibujen sin recargar la pagina. */
  function seccionesDelCarrito() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      if (ids.indexOf(el.dataset.sectionId) === -1) ids.push(el.dataset.sectionId);
    });
    return ids;
  }

  function avisar(cuerpo) {
    /* Tiene que ser `new Event`: en CustomEvent `detail` es de solo lectura y la
       asignacion se ignora en silencio. Misma trampa documentada en ms-oferta. */
    var evento = new Event('cart:update', { bubbles: true });
    evento.detail = {
      resource: cuerpo,
      sourceId: FUENTE,
      data: {
        source: FUENTE,
        itemCount: cuerpo && cuerpo.item_count,
        sections: cuerpo && cuerpo.sections
      }
    };
    document.dispatchEvent(evento);
  }

  /* ── EL TOPE, TAMBIEN EN PANTALLA ──
     Corregir el carrito despues no basta: el cliente ve el boton «+» activo,
     lo aprieta, y aunque el guardian lo devuelva, la sensacion es que si se
     puede. Aqui apagamos el «+» de las lineas que ya estan en su tope. El
     guardian de arriba sigue siendo la red: esto es la puerta, no la reja. */
  function ponerEstilos() {
    if (document.getElementById(ESTILO_ID)) return;
    var hoja = document.createElement('style');
    hoja.id = ESTILO_ID;
    hoja.textContent =
      '[data-ms-tope] .quantity-plus,[data-ms-tope] button[name="plus"]{' +
      'opacity:.28;cursor:not-allowed;pointer-events:none;}';
    (document.head || document.documentElement).appendChild(hoja);
  }

  function marcarFilas(carrito) {
    if (!carrito || !carrito.items) return;
    ponerEstilos();

    var topes = {};
    var packs = {};
    carrito.items.forEach(function (item) {
      if (esDependiente(item)) topes[item.key] = true;
      /* El frasco gratis tampoco se edita por linea: sale solo del 3x2. */
      if (esPack(item) || esRegalo(item)) packs[item.key] = true;
    });

    /* Las filas del carrito (cajon y pagina) traen data-key con la misma llave
       que devuelve cart.js — ver snippets/cart-products.liquid. */
    document.querySelectorAll('[data-key]').forEach(function (fila) {
      var llave = fila.getAttribute('data-key');
      var esTope = topes[llave] === true;
      var mas = fila.querySelector('.quantity-plus, button[name="plus"]');

      /* EL PACK NO SE EDITA POR LINEA. Sus dos mitades tienen que ir parejas,
         asi que dejar el «+» y el «−» sueltos solo sirve para que el cliente
         rompa el pack y el guardian se lo tenga que deshacer en la cara. Se
         esconden los dos y queda el numero, que es informacion. El bote de
         basura se queda: quitar el pack entero SI es una decision legitima. */
      if (packs[llave] === true) {
        fila.setAttribute('data-ms-pack', '1');
      } else if (fila.hasAttribute('data-ms-pack')) {
        fila.removeAttribute('data-ms-pack');
      }

      if (esTope) {
        fila.setAttribute('data-ms-tope', '1');
        if (mas) {
          mas.disabled = true;
          mas.setAttribute('aria-disabled', 'true');
          mas.setAttribute('title', 'Solo 1 por pedido');
        }
      } else if (fila.hasAttribute('data-ms-tope')) {
        /* Solo devolvemos lo que nosotros apagamos: si la fila nunca fue
           nuestra, no se toca (el tema desactiva el «+» por inventario). */
        fila.removeAttribute('data-ms-tope');
        if (mas) {
          mas.disabled = false;
          mas.removeAttribute('aria-disabled');
          mas.removeAttribute('title');
        }
      }
    });
  }

  /* Manda las correcciones y avisa al tema para que repinte el carrito. */
  function aplicar(updates) {
    var secciones = seccionesDelCarrito();
    return fetch(raiz() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        updates: updates,
        sections: secciones.length ? secciones.join(',') : undefined,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (cuerpo) {
        ultimoCarrito = cuerpo;
        avisar(cuerpo);
        /* Tras el aviso el tema repinta el carrito, asi que las marcas se
           vuelven a poner en la siguiente vuelta del hilo. */
        setTimeout(function () { marcarFilas(cuerpo); }, 60);
        return cuerpo;
      });
  }

  function revisar() {
    /* Devuelve la promesa: el interceptor de la caja necesita esperarla.
       Si ya hay una revision en vuelo, se comparte en vez de duplicarla. */
    if (trabajando) return enVuelo || Promise.resolve(null);
    trabajando = true;

    enVuelo = fetch(raiz() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (carrito) {
        ultimoCarrito = carrito;
        marcarFilas(carrito);

        var items = (carrito && carrito.items) || [];
        if (!items.length) return null;

        var updates = {};
        var hayCorreccion = false;

        // El 2x1 se revisa SIEMPRE, aunque no haya complementos en el carrito.
        if (corregir2x1(items, updates)) {
          hayCorreccion = true;
        }

        // Y el pack, igual: variante y plan tienen que ir emparejados.
        items.forEach(function (item) {
          if (!esPack(item) || packValido(item)) return;
          updates[item.key] = 0;
          hayCorreccion = true;
        });

        // ...y las dos mitades del pack, con la misma cantidad.
        if (corregirPack(items, updates)) {
          hayCorreccion = true;
        }

        /* Se cuenta con las cantidades que van a QUEDAR, no con las que
           llegaron. Antes se miraba el carrito tal cual, asi que si en esta
           misma pasada el guardian se estaba llevando el pack por estar roto,
           el complemento todavia veia un acompanante vivo y se salvaba: quedaba
           un frasco suelto a precio de complemento. Pasaba de verdad —pack
           roto + Citruro al 50% sobreviviendo solo. */
        function cantidadFinal(item) {
          return updates[item.key] !== undefined ? updates[item.key] : item.quantity;
        }

        /* El frasco gratis del 3x2 depende de los pagados, que ya quedaron
           corregidos arriba. */
        if (corregirRegalos(items, updates)) {
          hayCorreccion = true;
        }

        var vivos = items.filter(function (item) { return cantidadFinal(item) > 0; });
        var dependientes = vivos.filter(esDependiente);
        /* Un frasco gratis no acompania a nadie: un complemento al 50% con solo
           un regalo al lado seria un pedido de $449.50 con dos frascos. */
        var acompaniantes = vivos.filter(function (item) {
          return !esDependiente(item) && !esRegalo(item);
        }).length;

        if (!dependientes.length) {
          if (!hayCorreccion) return null;
          return aplicar(updates);
        }

        if (acompaniantes > 0) {
          /* Hay quien los acompanie, asi que se quedan — pero UNO de cada uno.
             El complemento se vende como «llega una sola vez»; sin tope son 3
             unidades a mitad de precio. Pedido #14813 del 28-ago: 3 x Honey Dee
             Complemento, sin producto principal, $1,078.80. Lo mismo vale para
             el upsell de Kaching: su precio es de prueba, no de catalogo. */
          var sobra = false;
          dependientes.forEach(function (item) {
            if (item.quantity > MAX_POR_COMPLEMENTO) {
              updates[item.key] = MAX_POR_COMPLEMENTO;
              sobra = true;
            }
          });
          if (!sobra && !hayCorreccion) return null;
        } else {
          /* Nadie que los acompanie: fuera todos. */
          dependientes.forEach(function (item) { updates[item.key] = 0; });
        }

        return aplicar(updates);
      })
      .catch(function () {
        /* Nunca bloquear el carrito por culpa del guardian. */
      })
      .then(function (r) { trabajando = false; return r; },
            function () { trabajando = false; return null; });

    return enVuelo;
  }

  document.addEventListener('cart:update', function (e) {
    /* No perseguir el evento que dispara el propio guardian. */
    var d = e && e.detail && e.detail.data;
    if (d && d.source === FUENTE) return;
    revisar();
  });

  /* El tema repinta el carrito con morph cada vez que cambia algo, y ahi se
     lleva por delante nuestros atributos. En vez de adivinar cuando pasa, se
     vigila el DOM y se vuelven a poner con el ultimo carrito conocido. */
  (function vigilarRepintado() {
    var pendiente = null;
    new MutationObserver(function (mutaciones) {
      if (!ultimoCarrito || pendiente) return;
      var tocaCarrito = mutaciones.some(function (m) {
        return [].some.call(m.addedNodes, function (n) {
          return n.nodeType === 1 && (n.hasAttribute('data-key') || n.querySelector('[data-key]'));
        });
      });
      if (!tocaCarrito) return;
      pendiente = setTimeout(function () {
        pendiente = null;
        marcarFilas(ultimoCarrito);
      }, 30);
    }).observe(document.documentElement, { subtree: true, childList: true });
  })();

  /* LA CARRERA DE LA CAJA.
     El guardian es asincrono: quitar el producto principal y darle a «Pagar» de
     inmediato lo deja atras, y el complemento huerfano llega al checkout — que
     es pagina de Shopify, donde ya no corre nada nuestro. Por eso el clic a la
     caja se detiene, se revisa, y se deja pasar.
     FALLA ABIERTO a proposito: si la revision tarda mas de 1.5 s o truena, el
     cliente pasa igual. Un guardian nunca debe impedir una compra. */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[name="checkout"], a[href*="/checkout"]');
    if (!t || t.dataset.msGuardPasa === '1') return;

    e.preventDefault();
    e.stopPropagation();

    var reloj = new Promise(function (res) { setTimeout(res, 1500); });
    Promise.race([revisar(), reloj]).then(function () {
      t.dataset.msGuardPasa = '1';
      t.click();
    });
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revisar);
  } else {
    revisar();
  }
})();
